"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Error_1 = require("./Error");
var SyncOverlay_1 = require("./SyncOverlay");
var AppHostError = /** @class */ (function (_super) {
    __extends(AppHostError, _super);
    function AppHostError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppHostError.prototype.componentWillMount = function () {
        this.props.host.setTitle("Error");
    };
    AppHostError.prototype.render = function () {
        return React.createElement(Error_1.Error, { className: "app-host-error", error: this.props.host.sync.error });
    };
    return AppHostError;
}(React.Component));
var AppHostContainerView = /** @class */ (function (_super) {
    __extends(AppHostContainerView, _super);
    function AppHostContainerView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppHostContainerView.prototype.render = function () {
        if (this.props.host.sync.error) {
            return this.props.onRenderError ? this.props.onRenderError(this.props) : React.createElement(AppHostError, __assign({}, this.props));
        }
        return this.props.host.view || null;
    };
    AppHostContainerView = __decorate([
        mobx_react_1.observer
    ], AppHostContainerView);
    return AppHostContainerView;
}(React.Component));
var AppHostContainer = /** @class */ (function (_super) {
    __extends(AppHostContainer, _super);
    function AppHostContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderSync = function () {
            return _this.props.onRenderSync(_this.props);
        };
        return _this;
    }
    AppHostContainer.prototype.componentWillMount = function () {
        if (!this.props.noLoadOnMount) {
            this.props.host.load();
        }
    };
    AppHostContainer.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(SyncOverlay_1.SyncOverlay, { sync: this.props.host.sync, onRenderSync: this.props.onRenderSync ? this._onRenderSync : undefined }),
            React.createElement(AppHostContainerView, __assign({}, this.props))));
    };
    return AppHostContainer;
}(React.Component));
exports.AppHostContainer = AppHostContainer;
